/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { object, Schema, string } from '../schema';

export interface GeoLocation {
  latitude: string;
  longitude: string;
}

export const geoLocationSchema: Schema<GeoLocation> = object({
  latitude: ['Latitude', string()],
  longitude: ['Longitude', string()],
});
